import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
export var locationMap = function locationMap(array) {
  console.log("INMAP");

  if (array.length) {
    return array.map(function (el) {
      return _objectSpread({
        aboutus_description: el.AboutUsDescription,
        address1: el.Address1,
        address2: el.Address2,
        alternate_name: el.AlternateName,
        avgwaittime: el.AvgWaitTime,
        beer_wine: el.BeerWine,
        careers: el.Careers,
        catering: el.Catering,
        catering_delivery: el.CateringDelivery,
        catering_deliveryavailable: el.CateringDeliveryAvailable,
        catering_deliverylaunchdate: el.CateringDeliveryLaunchDate,
        catering_menu: el.CateringMenu,
        clientkey: el.StoreNumber,
        city: el.City,
        country: el.Country,
        curbside: el.Curbside,
        detailLink: el.DetailLink,
        dinein: el.DineIn,
        dispatchindividual: el.DispatchIndividual,
        english_breakfast: el.EnglishBreakfast,
        english_lunchdinner: el.EnglishLunchDinner,
        familyvaluemeals: el.FamilyValueMeals,
        featuredmenu: el.FeaturedMenu,
        front_porch_dining: el.FrontPorchDining,
        frontporchdining: el.FrontPorchDining,
        ghostkitchen: el.GhostKitchen,
        cnbKitchen: el.CnbKitchen,
        cnbUberEatsUrl: el.CnbUberEatsUrl,
        cnbDoorDashUrl: el.CnbDoorDashUrl,
        latitude: el.Longitude,
        longitude: el.Longitude,
        name: el.Name,
        nowopen: el.NowOpen,
        olo_catering_unique_name: el.OloCateringUniqueName,
        olo_store: el.OloStore,
        olo_unique_name: el.OloUniqueName,
        onlineordering: el.OnlineOrdering,
        openingsoon: el.OpeningSoon,
        park: el.Park,
        pay_in_app: el.PayInApp,
        phone: el.Phone,
        pickup: el.PickUp,
        spanish_breakfast: el.SpanishBreakfast,
        spanish_lunchdinner: el.SpanishLunchDinner,
        specialhours: el.SpecialHours,
        specialnotes: el.SpecialNotes,
        state: el.State,
        storeaddress: {
          value: el.Address1
        },
        storename: {
          value: "".concat(el.Name, " - Store# ").concat(el.ClientKey)
        },
        storephone: {
          value: el.Phone
        },
        storeuid: el.StoreId,
        temporarilyclosed: el.TemporarilyClosed,
        vendorid: el.VendorId,
        vendoridcatering: el.VendorIdCatering,
        waitlist_flag: el.Waitlist,
        webaheadstatus: el.WebAheadStatus,
        _distance: isNaN(el.MilesFromSource) ? "" : el.MilesFromSource.toFixed(2),
        _distanceuom: isNaN(el.MilesFromSource) ? "" : "miles",
        postalcode: el.Zip
      }, el);
    });
  }
}; //Below  couldn't find/Save for later

/*
  carryout_curbside_friday_close:
  carryout_curbside_friday_open:
  carryout_curbside_monday_close:
  carryout_curbside_monday_open:
  carryout_curbside_saturday_close:
  carryout_curbside_saturday_open:
  carryout_curbside_sunday_close:
  carryout_curbside_sunday_open:
  carryout_curbside_thursday_close:
  carryout_curbside_thursday_open:
  carryout_curbside_tuesday_close:
  carryout_curbside_tuesday_open:
  carryout_curbside_wednesday_close:
  carryout_curbside_wednesday_open:
  carryout_pickup_friday_close:
  carryout_pickup_friday_open:
  carryout_pickup_monday_close:
  carryout_pickup_monday_open:
  carryout_pickup_saturday_close:
  carryout_pickup_saturday_open:
  carryout_pickup_sunday_close:
  carryout_pickup_sunday_open:
  carryout_pickup_thursday_close:
  carryout_pickup_thursday_open:
  carryout_pickup_tuesday_close:
  carryout_pickup_tuesday_open:
  carryout_pickup_wednesday_close:
  carryout_pickup_wednesday_open:
  catering_pickup_friday_close:
  catering_pickup_friday_open:
  catering_pickup_monday_close:
  catering_pickup_monday_open:
  catering_pickup_saturday_close:
  catering_pickup_saturday_open:
  catering_pickup_sunday_close:
  catering_pickup_sunday_open:
  catering_pickup_thursday_close:
  catering_pickup_thursday_open:
  catering_pickup_tuesday_close:
  catering_pickup_tuesday_open:
  catering_pickup_wednesday_close:
  catering_pickup_wednesday_open:
  bho: "[]", //Can't find in data
  catering_delivery_hours: "", //Dont see
  carryoutdelivery: "", //Dont see
  companyuid: el.CompanyUid,
  cateringtestdma: "", //donesee
  holidayhns: el.HolidayHns,
  exit: "148", //dontsee
  facebookpage: el.FacebookPage,
  fax:  "", //dontsee
  friday_close: el.FridayClose,
  friday_open: el.FridayOpen,
  icon: "default", //dont see
  individualmeals: el.IndividualMeals,
  integrated_carryout_curbside: "", //dontsee
  integratedcateringdelivery: el.IntegratedCateringDelivery,
  interstate: "", //dontsee
  labslocation: "", //dontsee
  notations: "", //dont see
  onlineorderingtest: "", //dont see
  openingdate: "", //dont see
  ordertalk_id: "",  //dont see
  localpage_image1: el.LocalPageImage1,
  localpage_image2: el.LocalPageImage2,
  localpage_image3: el.LocalPageImage3,
  max_live_date: el.MaxLiveDate,
  monday_close: el.MondayClose,
  monday_open: el.MondayOpen,
  pilot_program: "",
  possystem: "MAX",
  saturday_close: "10:00 PM"
  saturday_open: "7:00 AM"
  province: ""
  storehours: {sunday: {full: "7:00 AM - 9:00 PM", open: "7:00 AM", close: "9:00 PM"},…}
  sunday_close: el.SundayClose,
  sunday_open: el.SundayOpen,
  thursday_close: el.ThursdayClose,
  thursday_open: el.ThursdayOpen
  tuesday_close: el.TuesdayClose
  tuesday_open: el.TuesdayOpen
  uid: "930877361"
  wednesday_close: el.WednesdayClose
  wednesday_open: el.WednesdayOpen
  wteffective: "12/04/2020 10:54:41"
  yelpreopendate: ""
*/